import script from "./resolveProject.vue?vue&type=script&lang=ts&setup=true"
export * from "./resolveProject.vue?vue&type=script&lang=ts&setup=true"

import "./resolveProject.vue?vue&type=style&index=0&id=40ca1df0&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ca1df0"]])

export default __exports__